import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { useFrameStore } from '../seg-frame-store';
import { computeData } from '../helpers/frameLogic';
import PrintFrameSvg from './PrintFrameSvg.vue';
import HardwareLegend from "../HardwareLegend.vue";
import { HangingType } from "../helpers/segFrameBuilderTypes";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PrintProductionPage',
    props: {
        frame: { type: null, required: true },
        index: { type: Number, required: true },
        total: { type: Number, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const store = useFrameStore();
        const techData = computed(() => computeData({
            dims: props.frame.dims,
            rawCosts: store.rawCosts,
            tierPrices: store.tierPrices,
            pricingTier: props.frame.pricingTier,
            hangingOption: props.frame.hangingOption ?? HangingType.CLIPS,
        }));
        const qty = computed(() => props.frame.quantity ?? 1);
        const supportEndClipCount = computed(() => (techData.value?.hw?.supportEndClips ?? 0) * qty.value);
        const hwEntries = computed(() => {
            const hw = techData.value?.hw;
            if (!hw)
                return [];
            return Object.entries(hw)
                .filter(([key, v]) => key !== 'supportEndClips' && v > 0);
        });
        const formatHWLabel = (key) => key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase());
        const __returned__ = { props, store, techData, qty, supportEndClipCount, hwEntries, formatHWLabel, PrintFrameSvg, HardwareLegend };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
